const USER_COUNTRY_INFO = 'userCountryInfo'

export type UserCountryInfo = {
  countryLivingIn?: string
  countryLivingInDuration?: 'not_moved_yet' | '0_year' | '1_2_years' | '3_years_or_more'
  countryOrigin?: string
  countryTravellingTo?: string
  onboardingStep?: 'welcome' | 'where' | 'duration' | 'origin' | 'done'
  onboardingCompletedAt?: number
}

/** @deprecated use `getUserInfo` instead */
export async function getUserCountryInfo() {
  return storage.getValue<UserCountryInfo>(USER_COUNTRY_INFO)
}

export async function removeUserCountryInfo() {
  return storage.removeValue(USER_COUNTRY_INFO)
}
